import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Configuration} from '@shared/models/configuration';

/**
 * Created by khairul.basar on 2/16/2020.
 */

@Injectable()
export class FirmApiService {
  constructor(private httpClient: HttpClient) {
  }

  getSubAccountPackages(): Observable<any> {
    const adminPanelApi = Configuration.getConfig('AdminPanelApi');
    return this.httpClient.get<any>(`${adminPanelApi}Firm/SubAccountPackages`);
  }
}
